// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see WebViewViewAppEvent
 */
export var WebViewViewApp = function () { return ({
    name: "Web View ViewApp",
    parameters: {
        cdf_entity: "Web",
        cdf_action: "View",
    }
}); };
/**
 * @see WebViewViewPageEvent
 */
export var WebViewViewPage = function (_a) {
    var pageName = _a.pageName;
    return ({
        name: "Web View ViewPage",
        parameters: {
            cdf_entity: "Web",
            cdf_action: "View",
            page_name: pageName !== undefined && pageName !== null ? pageName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WebViewViewComponentEvent
 */
export var WebViewViewComponent = function (_a) {
    var pageName = _a.pageName, componentName = _a.componentName, componentType = _a.componentType;
    return ({
        name: "Web View ViewComponent",
        parameters: {
            cdf_entity: "Web",
            cdf_action: "View",
            page_name: pageName !== undefined && pageName !== null ? pageName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            component_name: componentName !== undefined && componentName !== null ? componentName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            component_type: componentType !== undefined && componentType !== null ? componentType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WebViewViewBlockerEvent
 */
export var WebViewViewBlocker = function (_a) {
    var clientScenario = _a.clientScenario, trackingFlowName = _a.trackingFlowName, blockerId = _a.blockerId, blockerType = _a.blockerType, groupId = _a.groupId, skippable = _a.skippable, isSupported = _a.isSupported, originatingFlowType = _a.originatingFlowType;
    return ({
        name: "Web View ViewBlocker",
        parameters: {
            cdf_entity: "Web",
            cdf_action: "View",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            tracking_flow_name: trackingFlowName !== undefined && trackingFlowName !== null ? trackingFlowName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            blocker_id: blockerId !== undefined && blockerId !== null ? blockerId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            blocker_type: blockerType !== undefined && blockerType !== null ? blockerType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            group_id: groupId !== undefined && groupId !== null ? groupId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            skippable: skippable !== undefined && skippable !== null ? skippable.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_supported: isSupported !== undefined && isSupported !== null ? isSupported.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            originating_flow_type: originatingFlowType !== undefined && originatingFlowType !== null ? originatingFlowType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WebViewUnsupportedFeatureEvent
 */
export var WebViewUnsupportedFeature = function (_a) {
    var source = _a.source, feature = _a.feature, action = _a.action, context = _a.context;
    return ({
        name: "Web View UnsupportedFeature",
        parameters: {
            cdf_entity: "Web",
            cdf_action: "View",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            feature: feature !== undefined && feature !== null ? feature.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            action: action !== undefined && action !== null ? action.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            context: context !== undefined && context !== null ? context.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WebViewPageHideEvent
 */
export var WebViewPageHide = function (_a) {
    var pageName = _a.pageName, trigger = _a.trigger;
    return ({
        name: "Web View PageHide",
        parameters: {
            cdf_entity: "Web",
            cdf_action: "View",
            page_name: pageName !== undefined && pageName !== null ? pageName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WebInteractClickEvent
 */
export var WebInteractClick = function (_a) {
    var pageName = _a.pageName, componentName = _a.componentName, componentType = _a.componentType;
    return ({
        name: "Web Interact Click",
        parameters: {
            cdf_entity: "Web",
            cdf_action: "Interact",
            page_name: pageName !== undefined && pageName !== null ? pageName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            component_name: componentName !== undefined && componentName !== null ? componentName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            component_type: componentType !== undefined && componentType !== null ? componentType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WebInteractToggleEvent
 */
export var WebInteractToggle = function (_a) {
    var pageName = _a.pageName, componentName = _a.componentName, componentType = _a.componentType, toggleState = _a.toggleState;
    return ({
        name: "Web Interact Toggle",
        parameters: {
            cdf_entity: "Web",
            cdf_action: "Interact",
            page_name: pageName !== undefined && pageName !== null ? pageName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            component_name: componentName !== undefined && componentName !== null ? componentName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            component_type: componentType !== undefined && componentType !== null ? componentType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            toggle_state: toggleState !== undefined && toggleState !== null ? toggleState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WebResponseSuccessEvent
 */
export var WebResponseSuccess = function (_a) {
    var apiName = _a.apiName;
    return ({
        name: "Web Response Success",
        parameters: {
            cdf_entity: "Web",
            cdf_action: "Response",
            api_name: apiName !== undefined && apiName !== null ? apiName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WebResponseErrorEvent
 */
export var WebResponseError = function (_a) {
    var apiName = _a.apiName, httpStatusCode = _a.httpStatusCode;
    return ({
        name: "Web Response Error",
        parameters: {
            cdf_entity: "Web",
            cdf_action: "Response",
            api_name: apiName !== undefined && apiName !== null ? apiName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            http_status_code: httpStatusCode !== undefined && httpStatusCode !== null ? httpStatusCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WebLoadCDNLoadFailedEvent
 */
export var WebLoadCDNLoadFailed = function (_a) {
    var pageName = _a.pageName, url = _a.url, cause = _a.cause;
    return ({
        name: "Web Load CDNLoadFailed",
        parameters: {
            cdf_entity: "Web",
            cdf_action: "Load",
            page_name: pageName !== undefined && pageName !== null ? pageName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            url: url !== undefined && url !== null ? url.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            cause: cause !== undefined && cause !== null ? cause.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WebDebugLogEvent
 */
export var WebDebugLog = function (_a) {
    var action = _a.action, description = _a.description;
    return ({
        name: "Web Debug Log",
        parameters: {
            cdf_entity: "Web",
            cdf_action: "Debug",
            action: action !== undefined && action !== null ? action.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            description: description !== undefined && description !== null ? description.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WebTaxesLoginSuccessEvent
 */
export var WebTaxesLoginSuccess = function (_a) {
    var category = _a.category, type = _a.type;
    return ({
        name: "Web Taxes LoginSuccess",
        parameters: {
            cdf_entity: "Web",
            cdf_action: "Taxes",
            category: category !== undefined && category !== null ? category.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WebCheckoutTrackUserEvent
 */
export var WebCheckoutTrackUser = function (_a) {
    var action = _a.action, customerRequestId = _a.customerRequestId, sessionRequestId = _a.sessionRequestId, detail = _a.detail;
    return ({
        name: "Web Checkout TrackUser",
        parameters: {
            cdf_entity: "Web",
            cdf_action: "Checkout",
            action: action !== undefined && action !== null ? action.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            customer_request_id: customerRequestId !== undefined && customerRequestId !== null ? customerRequestId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            session_request_id: sessionRequestId !== undefined && sessionRequestId !== null ? sessionRequestId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            detail: detail !== undefined && detail !== null ? detail.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WebCheckoutTrackPageEvent
 */
export var WebCheckoutTrackPage = function (_a) {
    var action = _a.action, customerRequestId = _a.customerRequestId, sessionRequestId = _a.sessionRequestId, detail = _a.detail;
    return ({
        name: "Web Checkout TrackPage",
        parameters: {
            cdf_entity: "Web",
            cdf_action: "Checkout",
            action: action !== undefined && action !== null ? action.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            customer_request_id: customerRequestId !== undefined && customerRequestId !== null ? customerRequestId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            session_request_id: sessionRequestId !== undefined && sessionRequestId !== null ? sessionRequestId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            detail: detail !== undefined && detail !== null ? detail.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WebCheckoutTrackViewEvent
 */
export var WebCheckoutTrackView = function (_a) {
    var action = _a.action, customerRequestId = _a.customerRequestId, sessionRequestId = _a.sessionRequestId, detail = _a.detail;
    return ({
        name: "Web Checkout TrackView",
        parameters: {
            cdf_entity: "Web",
            cdf_action: "Checkout",
            action: action !== undefined && action !== null ? action.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            customer_request_id: customerRequestId !== undefined && customerRequestId !== null ? customerRequestId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            session_request_id: sessionRequestId !== undefined && sessionRequestId !== null ? sessionRequestId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            detail: detail !== undefined && detail !== null ? detail.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WebCheckoutTrackSystemEvent
 */
export var WebCheckoutTrackSystem = function (_a) {
    var action = _a.action, customerRequestId = _a.customerRequestId, sessionRequestId = _a.sessionRequestId, detail = _a.detail;
    return ({
        name: "Web Checkout TrackSystem",
        parameters: {
            cdf_entity: "Web",
            cdf_action: "Checkout",
            action: action !== undefined && action !== null ? action.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            customer_request_id: customerRequestId !== undefined && customerRequestId !== null ? customerRequestId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            session_request_id: sessionRequestId !== undefined && sessionRequestId !== null ? sessionRequestId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            detail: detail !== undefined && detail !== null ? detail.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WebCommerceGrantFlowEvent
 */
export var WebCommerceGrantFlow = function (_a) {
    var customerRequestId = _a.customerRequestId, brand = _a.brand, integration = _a.integration;
    return ({
        name: "Web Commerce GrantFlow",
        parameters: {
            cdf_entity: "Web",
            cdf_action: "Commerce",
            customer_request_id: customerRequestId !== undefined && customerRequestId !== null ? customerRequestId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            brand: brand !== undefined && brand !== null ? brand.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            integration: integration !== undefined && integration !== null ? integration.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WebCommerceLoginEvent
 */
export var WebCommerceLogin = function (_a) {
    var customerRequestId = _a.customerRequestId, brand = _a.brand, standalone = _a.standalone, integration = _a.integration;
    return ({
        name: "Web Commerce Login",
        parameters: {
            cdf_entity: "Web",
            cdf_action: "Commerce",
            customer_request_id: customerRequestId !== undefined && customerRequestId !== null ? customerRequestId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            brand: brand !== undefined && brand !== null ? brand.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            standalone: standalone !== undefined && standalone !== null ? standalone.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            integration: integration !== undefined && integration !== null ? integration.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see WebConsentConsentGivenEvent
 */
export var WebConsentConsentGiven = function (_a) {
    var consentGroups = _a.consentGroups;
    return ({
        name: "Web Consent ConsentGiven",
        parameters: {
            cdf_entity: "Web",
            cdf_action: "Consent",
            consentGroups: consentGroups !== undefined && consentGroups !== null ? consentGroups.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
